import React from 'react'
import injectSheet from 'react-jss'
import { Image } from '../../'

const OfferHouseType = (props) => {
  const {
    classes,
    houseTypeSelection,
  } = props

  return (
    <div className={`${classes.container}`}>
      <Image
        alt={houseTypeSelection.houseType && houseTypeSelection.houseType.title}
        src={houseTypeSelection.houseType && houseTypeSelection.houseType.images[0]}
        fit="cover"
      />
    </div>
  )
}

const styles = theme => ({
  container: {
    height: '300px',
    padding: `${theme.sizes.gutter / 2}px`,
    paddingBottom: `${theme.sizes.gutter}px`,
  },
})


export default injectSheet(styles)(OfferHouseType)



// WEBPACK FOOTER //
// ./src/modules/offer/components/offerHouseType.jsx